import LoadableGoogleMap from './loadable_google_map'
import ReactComponent from 'lib/modulor/react_component'

ReactComponent.register(LoadableGoogleMap, 'Modulor.GoogleMap')
